import $ from 'jquery';
import logger from 'OK/logger';
import { getPlayerContainer, getPlayer, getPlayerId, stop as stopVideo } from 'OK/OKVideo';

var CSS_SELECTOR_HOLDER = '.sticky-player',
    CSS_SELECTOR_CONTAINER = '.sticky-player_cnt',
    CSS_SELECTOR_PLAYER_SIZER = '.js-modal-sizer',

    CSS_SELECTOR_MOVE_ACTION = '.js-modal-move',
    CSS_SELECTOR_CLOSE_ACTION = '.sticky-player_close',
    CSS_SELECTOR_PIN_ACTION = '.sticky-player_pin',

    CSS_CLASS_PINNED_STATE = '__pinned',
    CSS_CLASS_ACTIVE_STATE = '__active',

    CSS_CLASS_INVISIBLE = 'invisible';

var LOG_SERVICE = 'video.autoplay.flow',
    LOG_CLOSE_STICKY = 'close_sticky',
    LOG_PIN_STICKY = 'pin_sticky',
    LOG_UNPIN_STICKY = 'unpin_sticky',
    LOG_MOVE = 'move',
    LOG_RESIZE = 'resize';

/**
 * ID текущего залипшего плеера
 * @type {String}
 * @private
 */
var _id = null;

/**
 * Признак того что плеер закрепили
 * @type {boolean}
 * @private
 */
var _pinned = false;

/**
 * UI элементы
 * @type {Array|any|Element}
 */
var holder,
    container,
    playerSizer,

    moveAction,
    pinAction,
    closeAction;

/**
 * Обработчик скрытия по клику на крестик
 * @private
 */
var _closeClickHandler = function () {
    updateView({
        reset: true
    });

    // Т.к. он ещё играет, стопанём
    stopVideo();

    logger.success(LOG_SERVICE, LOG_CLOSE_STICKY);
};

var _pinClickHandler = function () {
    var newPinnedStatus = !_pinned;

    updateView({
        pinned: newPinnedStatus
    });

    if (newPinnedStatus) {
        logger.success(LOG_SERVICE, LOG_PIN_STICKY);
    } else {
        logger.success(LOG_SERVICE, LOG_UNPIN_STICKY);
    }
};

/**
 * Id текущего залипшего плеера
 * @static
 * @returns {String}
 */
function getId() {
    return _id
}

/**
 * Есть ли залипший плеер на странице
 * @static
 * @returns {boolean}
 */
function isActive() {
    return _id !== null
}

/**
 * Закреплён ли залипший плеер
 * @static
 * @returns {boolean}
 */
function isPinned() {
    return isActive() && _pinned;
}

/*
 * Обновляет отображение
 * @param {{}=} options
 */
function updateView(options) {
    var opt = Object.assign({
        originalHolder: getPlayerContainerWrapper(),
        reset: false,
        pinned: false,
        clone: false
    }, options || {});

    holder.classList.toggle(CSS_CLASS_ACTIVE_STATE, !opt.reset);
    holder.classList.toggle(CSS_CLASS_PINNED_STATE, opt.pinned);

    if (opt.reset) {
        if (opt.originalHolder) {
            // Скроем заглушку плеера с обложкой и кнопкой плей
            getPlayerContainer().classList.add(CSS_CLASS_INVISIBLE);

            opt.originalHolder.appendChild(getPlayer());
        }

        _id = null;
        _pinned = false;
        container.innerHTML = '';

        return;
    }

    if (opt.clone) {
        container.innerHTML = '';
        container.appendChild(getPlayer());
        _id = getPlayerId();

        // Оставим видимой заглушку плеера с обложкой и кнопкой плей
        getPlayerContainer().classList.remove(CSS_CLASS_INVISIBLE);
    }

    _pinned = opt.pinned;
}

function activate() {
    var $holder = $(CSS_SELECTOR_HOLDER);

    holder = document.querySelector(CSS_SELECTOR_HOLDER);
    container = holder.querySelector(CSS_SELECTOR_CONTAINER);
    playerSizer = document.querySelector(CSS_SELECTOR_PLAYER_SIZER);

    moveAction = holder.querySelector(CSS_SELECTOR_MOVE_ACTION);
    closeAction = holder.querySelector(CSS_SELECTOR_CLOSE_ACTION);
    pinAction = holder.querySelector(CSS_SELECTOR_PIN_ACTION);

    closeAction.addEventListener('click', _closeClickHandler);
    pinAction.addEventListener('click', _pinClickHandler);

    var minWidth = parseInt(holder.getAttribute('data-width'), 10) || 264,
        $doc = $(document),
        scale = 16 / 10,
        storageWidth = OK.VideoPlayer.storage.getMiniPlayerWidth(),
        storageLeft = OK.VideoPlayer.storage.getMiniPlayerLeft(),
        storageTop = OK.VideoPlayer.storage.getMiniPlayerTop();


    // Init draggable
    import('jquery.ui.draggable').then(m => m && m.default || m).then(function() {
        $holder.draggable({
            handle: CSS_SELECTOR_MOVE_ACTION,
            scroll: false,
            containment: playerSizer,
            snap: CSS_SELECTOR_PLAYER_SIZER,
            snapMode: 'inner',
            start: function(e) {
                logger.success(LOG_SERVICE, LOG_MOVE);
            },
            drag: function(e, ui) {
                OK.VideoPlayer.storage.setMiniPlayerLeft(ui.position.left);
                OK.VideoPlayer.storage.setMiniPlayerTop(ui.position.top);
            }
        });
    });

    // Init resizable

    playerSizer.classList.add(CSS_CLASS_ACTIVE_STATE);

    import('jquery.ui.resizable').then(m => m && m.default || m).then(function() {
        $holder.resizable({
            handles: null,
            aspectRatio: scale,
            distance: 5,
            minWidth: minWidth,
            containment: playerSizer,
            create: function() {
                // Вычислим размеры
                var viewportWidth = playerSizer.clientWidth,
                    viewportHeight = playerSizer.clientHeight,
                    width = (!storageWidth || storageWidth >= viewportWidth || storageWidth / scale >= viewportHeight) ? minWidth : storageWidth,
                    height = width / scale;

                // (!) Сначала установим размеры элементы, чтобы дальнейшие вычисления были верны
                $holder.css({
                    width: width,
                    height: height
                });

                // Вычислим позицию слева
                var left = 0;
                if (storageLeft !== null) {
                    var containerWidth = $holder.outerWidth();
                    if (storageLeft + containerWidth > viewportWidth) {
                        // Уехали за правый край
                        left = viewportWidth - containerWidth;
                    } else {
                        left = storageLeft;
                    }
                }

                // Вычислим позицию сверху
                var top = $holder.offset().top - $doc.scrollTop();
                if (storageTop !== null) {
                    top = Math.min(storageTop, top);
                }

                // Изменим позиционирование
                $holder.css({
                    bottom: 'auto',
                    right: 'auto',
                    top: Math.max(top, 0),
                    left: Math.max(left, 0)
                });
            },
            start: function() {
                logger.success(LOG_SERVICE, LOG_RESIZE);
            },
            resize: function(e, ui) {
                OK.VideoPlayer.storage.setMiniPlayerWidth(ui.element[0].clientWidth);
            }
        });
    });
}

function deactivate() {
    closeAction.removeEventListener('click', _closeClickHandler);
    pinAction.removeEventListener('click', _pinClickHandler)
}

export default { activate, deactivate, updateView, isActive, isPinned, getId };

export { activate, deactivate, updateView, isActive, isPinned, getId };
